<template>
  <div>
    <div class="flex justify-between gap-x-6 sp-flex-direction-column">
      <div>
        <div class="title-lg">
          <span
            v-for="(businessAxes, index) in serviceCase.businessAxes"
            :key="businessAxes.id"
          >
            {{ businessAxes.text
            }}{{ serviceCase.businessAxes.length - 1 !== index ? '/' : '' }}
          </span>
        </div>
        <div v-if="serviceCase.buyerName" class="body-md text-gray-62 mt-1">
          {{ serviceCase.buyerName }}
        </div>
        <div
          class="flex items-center mt-2 sp-flex-direction-column sp-flex-row-gap sp-flex-align-start"
        >
          <span
            v-for="buyerProblemTag in serviceCase.buyerProblemTags"
            :key="buyerProblemTag.option_id"
            class="body-sm py-0.5 px-2 bg-gray-08 rounded-sm mr-1"
          >
            {{ buyerProblemTag.text }}
          </span>
        </div>
        <a
          v-if="serviceCase.linkUrl"
          :href="serviceCase.linkUrl"
          target="_blank"
          class="body-md mt-1 inline-block"
        >
          <div class="flex items-center">
            {{ serviceCase.linkUrl }}
            <img
              class="w-3.5 h-3.5 ml-1 inline"
              src="@/assets/icons/OpenGray.svg"
              alt=""
            />
          </div>
        </a>
      </div>
      <div
        v-if="serviceCase.imageUrl"
        class="border border-gray-12 rounded-xl overflow-hidden shrink-0 flex applys-center justify-center flex-none sp-image-content"
      >
        <img
          :src="serviceCase.imageUrl"
          alt=""
          class="max-w-full max-h-full m-auto"
        />
      </div>
    </div>
    <div
      :id="'serviceCaseCollapse-' + serviceCase.id"
      class="accordion-collapse collapse mt-4 !visible hidden"
      data-te-collapse-item
    >
      <!--取引先情報-->
      <div
        v-if="
          (serviceCase.subIndustries && serviceCase.subIndustries[0]) ||
          (serviceCase.mainIndustries && serviceCase.mainIndustries[0]) ||
          (serviceCase.customerEmployeeNumber &&
            serviceCase.customerEmployeeNumber[0])
        "
        class="bg-gray-08 rounded px-3 py-2"
      >
        <div class="title-sm">取引先情報</div>
        <div
          v-if="
            (serviceCase.subIndustries && serviceCase.subIndustries[0]) ||
            (serviceCase.mainIndustries && serviceCase.mainIndustries[0])
          "
          class="body-sm"
        >
          {{
            serviceCase.subIndustries && serviceCase.subIndustries[0]
              ? serviceCase.subIndustries[0].text
              : ''
          }}
          {{
            serviceCase.subIndustries &&
            serviceCase.subIndustries[0] &&
            serviceCase.mainIndustries &&
            serviceCase.mainIndustries[0]
              ? '/'
              : ''
          }}
          {{
            serviceCase.mainIndustries && serviceCase.mainIndustries[0]
              ? serviceCase.mainIndustries[0].text
              : ''
          }}
        </div>
        <div
          v-if="
            serviceCase.customerEmployeeNumber &&
            serviceCase.customerEmployeeNumber[0]
          "
          class="body-sm"
        >
          {{
            serviceCase.customerEmployeeNumber &&
            serviceCase.customerEmployeeNumber[0]
              ? `社員数：${serviceCase.customerEmployeeNumber[0].text}`
              : ''
          }}
        </div>
      </div>
      <!--↑取引先情報-->
      <!--↓依頼企業の課題-->
      <div
        v-if="serviceCase.buyerProblem"
        class="mt-4 pb-4 border-b border-gray-12 box-border"
      >
        <div class="title-md">依頼企業の課題</div>
        <div class="body-md mt-2 whitespace-pre-wrap break-all">
          {{ serviceCase.buyerProblem }}
        </div>
      </div>
      <!--↑依頼企業の課題-->
      <!--↓提供した業務-->
      <div
        v-if="serviceCase.providedService"
        class="mt-4 pb-4 border-b border-gray-12"
      >
        <div class="title-md">提供した業務</div>
        <div class="body-md mt-2 whitespace-pre-wrap break-all">
          {{ serviceCase.providedService }}
        </div>
      </div>
      <!--↑提供した業務-->
      <div
        v-if="serviceCase.totalCost"
        class="flex items-center justify-end mt-4"
      >
        <div>
          <span class="title-sm mr-1">合計費用</span>
          <span class="title-lg">{{ serviceCase.totalCost }}</span>
        </div>
      </div>
      <div
        v-if="serviceCase.isImitsu"
        class="mt-1 text-right body-sm text-gray-62 sp-text-left"
      >
        {{
          serviceCase.isImitsu.text ===
          'PRONIアイミツ/PRONIアイミツメンバーズでの受注実績'
            ? '本実績はPRONIアイミツ/PRONIアイミツメンバーズの受注案件です。'
            : '本実績はPRONIアイミツ/PRONIアイミツメンバーズでの受注案件ではありません。'
        }}
      </div>
    </div>
  </div>
  <div
    class="flex justify-center"
    :class="[state.collapseOpened ? 'mt-4' : 'mt-2']"
  >
    <button
      type="button"
      @click="toggleCollapse(serviceCase.id)"
      class="button-md text-primary-light-high py-2 rounded-lg w-full inline-block hover:bg-primary-state-hover"
      :class="[state.collapseOpened ? 'self-start' : 'self-end']"
      data-te-collapse-init
      data-te-collapse-collapsed
      :data-te-target="'#serviceCaseCollapse-' + serviceCase.id"
    >
      <span v-if="state.collapseOpened" class="align-center">
        <img
          src="@/assets/icons/ChevronUpCoral.svg"
          alt=""
          class="w-6 h-6 mr-2 inline"
        />折りたたむ
      </span>
      <span v-else class="align-center">
        <img
          src="@/assets/icons/ChevronDownCoral.svg"
          alt=""
          class="w-6 h-6 mr-2 inline"
        />取引先情報・提供した業務など
      </span>
    </button>
  </div>
</template>

<script>
import { reactive } from 'vue';

export default {
  props: {
    serviceCase: Object,
  },
  setup() {
    const state = reactive({
      collapseOpened: false,
    });
    const toggleCollapse = () => {
      state.collapseOpened = !state.collapseOpened;
    };
    return {
      state,
      toggleCollapse,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-shadow:hover {
  box-shadow: 0 0 8px rgba(102, 113, 140, 0.3);
}
.sp-image-content {
  width: 200px;
  height: 143px;
}
@media (max-width: 640px) {
  .sp-flex-direction-column {
    flex-direction: column;
  }
  .sp-flex-align-start {
    align-items: start;
  }
  .sp-flex-row-gap {
    row-gap: 2px;
  }
  .sp-image-content {
    width: 100%;
  }
  .sp-text-left {
    text-align: left;
  }
}
</style>
